// extracted by mini-css-extract-plugin
export default {"title-line-clamp":"NewsCardShare_title-line-clamp__Frkkj"};